import makeFilterContext from 'utils/dashboard/factories/filters/context/makeFilterContext';

import useUserOnboardingFormState from './useUserOnboardingFormState';

export const {
  FilterContext: Context,
  FilterProvider: Provider,
  useFilterContext: useContext,
} = makeFilterContext(useUserOnboardingFormState);
